/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'quotes': {
    width: 16,
    height: 12,
    viewBox: '0 0 16 12',
    data: `<path pid="0" d="M.297 12l2.727-5.627h-.059c-.79 0-1.482-.287-2.075-.861C.297 4.938 0 4.211 0 3.33 0 2.373.336 1.59 1.008.976 1.72.326 2.59 0 3.618 0c1.027 0 1.877.325 2.55.976.711.65 1.067 1.435 1.067 2.354 0 .574-.099 1.13-.297 1.665a12.355 12.355 0 0 1-.652 1.608L3.676 12H.297zm8.765 0l2.728-5.627h-.06c-.79 0-1.482-.287-2.075-.861-.593-.574-.89-1.301-.89-2.182 0-.957.336-1.741 1.008-2.354.712-.65 1.582-.976 2.61-.976 1.027 0 1.877.325 2.55.976C15.643 1.626 16 2.411 16 3.33c0 .574-.099 1.13-.296 1.665a12.368 12.368 0 0 1-.653 1.608L12.441 12h-3.38z"/>`
  }
})
